import { providersService } from 'src/config/rootService';
import { RootState } from 'src/config/rootStore';
import { CoachAssignmentNode, CoachNode } from 'src/generated/webapp_gql';
import { ProviderType } from 'src/modules/user/models/user';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

export interface ProvidersState {
    availableCoaches: CoachNode[];
    availableTherapists: CoachNode[];
    myProviders: CoachAssignmentNode[];
    fetchCompleted: boolean;
}

interface Payload {
    payload: CoachNode[];
}

const defaultState: ProvidersState = {
    availableCoaches: [],
    availableTherapists: [],
    myProviders: [],
    fetchCompleted: false,
};

export const providers = {
    state: defaultState,
    reducers: {
        addMyProviders: (
            state: ProvidersState,
            payload: CoachAssignmentNode[] = [],
        ): ProvidersState => {
            state.myProviders = payload;
            state.fetchCompleted = true;

            return state;
        },
        removeMyProvider: (state: ProvidersState, payload: string): ProvidersState => {
            const newMyProviders = state.myProviders.filter(({ coach }) => coach?.uuid !== payload);
            state.myProviders = newMyProviders;

            return state;
        },
        addAvailableCoaches: (state: ProvidersState, payload: CoachNode[] = []): ProvidersState => {
            state.availableCoaches = payload;

            return state;
        },
        addAvailableTherapists: (
            state: ProvidersState,
            payload: CoachNode[] = [],
        ): ProvidersState => {
            state.availableTherapists = payload;

            return state;
        },
        'authentication/logout': () => {
            return defaultState;
        },
    },
    effects: dispatch => ({
        async fetchMyProviders(_payload: undefined, state: RootState): Promise<void> {
            const user = getUserInformation(state);

            const providersData = await providersService.fetchMyProviders(user.uuid);

            dispatch.providers.addMyProviders(providersData);
        },
        async fetchAvailableCoaches(): Promise<void> {
            const providersData = await providersService.fetchAvailableProviders(
                ProviderType.COACH,
            );

            dispatch.providers.addAvailableCoaches(providersData);
        },
        async fetchAvailableTherapists(): Promise<Payload> {
            const providersData = await providersService.fetchAvailableProviders(
                ProviderType.THERAPIST,
            );

            return dispatch.providers.addAvailableTherapists(providersData);
        },
    }),
};
